import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import { Divider, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../src/i18n';
import CardBox from '../../CardBox';
import Title from '../../Title';
import { TP } from '../../../constants/consts';
import { colors } from '../../../constants/styleConstants';
import ProductionCommonInfo from '../EditProductionCardLayout/ProductionCommonInfo';
import ProductionDatesContent from '../../ProductionDatesContent';
import { getGroupedProductionsDateForTheCard } from '../../../utils/common';

const useStyles = makeStyles(() => ({
  cardBox: {
    width: '100%',
    alignItems: 'flex-start',
  },
  productionSectionWrapper: {
    width: '100%',
    padding: '10px 13px 16px',
  },
  productionHeaders: {
    background: colors.background.grayCard,
    padding: '3px 10px',
    marginTop: 10,
  },
  divider: {
    width: '100%',
  },
  productionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  closeIcon: {
    padding: 0,
  },
  dates: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const SelectedProductionCard = ({ production, onClose, additionalInfoBlock }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <CardBox className={classes.cardBox}>
      <div className={classes.productionSectionWrapper}>
        <div className={classes.productionHeader}>
          <Title>{t(`${TP}.FN_SELECTED_PRODUCTION`)}</Title>
          {onClose && (
            <IconButton className={classes.closeIcon} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
        <Grid container item sm={12} xs={12} md={12} className={classes.productionHeaders}>
          <ProductionCommonInfo production={production} withEmpty={false} />
          <ProductionDatesContent
            formattedDates={getGroupedProductionsDateForTheCard(production, false)}
            className={classes.dates}
          />
        </Grid>
      </div>
      {additionalInfoBlock && (
        <>
          <Divider className={classes.divider} />
          <div className={classes.productionSectionWrapper}>{additionalInfoBlock}</div>
        </>
      )}
    </CardBox>
  );
};

SelectedProductionCard.propTypes = {
  production: PropTypes.object.isRequired,
  additionalInfoBlock: PropTypes.node,
};

export default SelectedProductionCard;
